import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { FormField } from "@/components/Interface/FormFields/FormField/FormField";
import { DeviceDetailsForm } from "@/components/Portal/Cockpit/DeviceManagement/Details/Details";
import { DetailsChangeRow } from "@/components/Portal/Cockpit/DeviceManagement/Details/DetailsChangeRow/DetailsChangeRow";
import { DEFAULT_TEXT_FIELD_REGEX } from "@/utils/constants";

export const DeviceNameRow = () => {
  const { t } = useTranslation();

  const {
    watch,
    setValue,
    register,
    formState: { errors },
  } = useFormContext<DeviceDetailsForm>();
  const alias = watch("alias");
  const hasValidationErrors = !!Object.keys(errors).length;

  return (
    <DetailsChangeRow
      label={alias}
      header={t("portal:common.device.attributes.deviceName")}
      isSaveDisabled={hasValidationErrors}
    >
      <FormField<DeviceDetailsForm>
        ariaLabel={t("portal:common.device.attributes.deviceName")}
        id="device-name-input"
        errors={errors}
        register={register}
        name="alias"
        options={{
          onChange: (e: KeyboardEvent) => {
            const input = e.target as HTMLInputElement;
            let value = input.value;
            if (value.length > 50) {
              value = value.substring(0, 50);
            }
            setValue("alias", value);
          },
          required: t("translation:label.validation.required"),
          pattern: {
            message: t(
              "translation:Common.generalForm.error.genericRegexError",
            ),
            value: DEFAULT_TEXT_FIELD_REGEX,
          },
          setValueAs: (value: string) => value?.trim(),
        }}
      />
    </DetailsChangeRow>
  );
};
